export const ONBOARDING_CATEGORIES = [
  'happier',
  'wealthier',
  'productive',
  'smarter',
  'focused',
  'less stressed',
  'a better partner',
  'other',
];

export const SECTION_TYPE = [
  'todaysPicks',
  'updateData',
  'survey',
  'collectionList',
  'collectionListMore',
  'collectionSection',
  'userNewLessons',
  'userMissedSessions',
  'goalsList',
  'journal',
  'journalTab',
  'unlockSubscription',
  'bundleList',
  'notes',
  'stats',
  'yourPurchases',
  'savedContentGroups',
  'gifts',
  'health',
  'dailyAluxSessions',
  'downloads',
  'favorites',
  'recentlyPlayed',
  'recentlyPlayedAuthors',
  'userPaths',
  'learningPath',
  'learningPathProgress',
  'goalBasedCollections',
  'trendingAuthors',
  'trendingCommunities',
  'trendingTopics',
  'weeklyStrategicReps',
];
export const CELL_TYPE = [
  'largeCarousel',
  'wideList',
  'defaultCarousel',
  'authorCarousel',
  'pillarCard',
  'twoColumnsList',
  'simpleCard',
  'listCard',
  'simpleCard2',
  'playProgressCard',
];
export const SEE_ALL_CELL_TYPE = ['wideList', 'twoColumnsList', 'listCard'];

export const SUBSCRIPTION_TYPE = {
  monthly: 'com.alux.sub.monthly',
  monthlyNoTrial: 'com.alux.sub.monthly.notrial',
  yearly: 'com.alux.sub.yearly',
  yearlyNoTrial: 'com.alux.sub.yearly.notrial',
};

export const ACCESS_TYPE = ['free', 'subscription', 'paidSubscription', 'purchase', 'noPayment'];
export const SPECIAL_ACCESS_TYPES = ['free', 'yearlySubscriptionOnly'];

export const GROUP_TYPE = ['pack', 'layer', 'trial_lesson', 'sleep_story', 'rags_to_riches_story'];
export const CONTENT_TYPES = ['story', 'lesson', 'note', 'pack', 'influencer_pack'];
export const CONTENT_GROUP_TYPES = ['collection', 'bundle'];
export const CONTENT_GROUP_SUBTYPES = ['dailyAlux'];
export const CONTENT_GROUP_STATUS_TYPES = ['readyToPlay', 'minimal'];
export const FETCH_RULE_TYPES = ['static', 'pillar', 'category', 'authors'];
export const DEAL_TYPES = ['product', 'subscription'];

export type SectionType = (typeof SECTION_TYPE)[number];
export type CellType = (typeof CELL_TYPE)[number];
export type OnboardingCategoryType = (typeof ONBOARDING_CATEGORIES)[number];
export type AccessType = (typeof ACCESS_TYPE)[number];
export type SpecialAccessType = (typeof SPECIAL_ACCESS_TYPES)[number];
export type GroupType = (typeof GROUP_TYPE)[number];
export type ContentType = (typeof CONTENT_TYPES)[number];
export type ContentGroupType = (typeof CONTENT_GROUP_TYPES)[number];
export type ContentGroupSubtype = (typeof CONTENT_GROUP_SUBTYPES)[number];
export type ContentGroupStatusType = (typeof CONTENT_GROUP_STATUS_TYPES)[number];
export type FetchRuleType = (typeof FETCH_RULE_TYPES)[number];
export type DealType = (typeof DEAL_TYPES)[number];

export interface IsContentType {
  id: string;
  contentType: ContentType;
  publishedAtDate: Date | undefined;
  publishedAt: number | undefined;
  title: string;
  category: string;
  imageUrl?: string;
}

export interface IsLinkedToContent {
  linkedContentId: string;
  linkedContentType: ContentType;
  linkedContentTitle: string;
}

export interface IsPartOfAContentGroup {
  groupSize?: number;
  groupId?: string;
  groupType?: GroupType;
  groupPosition?: number;
}

export interface IsLinkedToContentGroup {
  groupSize?: number;
  groupId?: string;
  groupIndex?: number;
}

export interface HasCreatedAndUpdatedAt {
  createdAtDate: Date;
  updatedAtDate: Date;
}

export interface HasKeyTakeaways {
  keyTakeaways: string[];
}

export interface FirebaseObject extends HasCreatedAndUpdatedAt {
  id: string;
}

export interface HasCategories {
  category: string;
}

export interface HasImage {
  imageUrl?: string;
  imagePath?: string;
}

export interface HasDeviceName {
  deviceName: string;
}

export interface CanBeFeatured {
  featuredSortIndex: number;
}

export interface MediaContentObject extends HasImage {
  title: string;
  audioStreamPath?: string;
  videoStreamPath?: string;
  totalLength: number;
  contentUrl?: string;
}

export interface PlaybackState extends HasCreatedAndUpdatedAt, IsLinkedToContent, IsLinkedToContentGroup {
  isFinished: boolean;
  progress: number;
  totalLength: number;
  updatedAt: number;
}

export interface LikeState extends HasCreatedAndUpdatedAt, IsLinkedToContent {
  isLike: boolean;
  createdAt: number;
  updatedAt: number;
}

export interface FavoriteState extends HasCreatedAndUpdatedAt, IsLinkedToContent {
  createdAt: number;
  updatedAt: number;
}

export interface ProfileStats {
  finishedContent: number;
  finishedDailyLessons: number;
  longestStreak: number;
  dailyStreak: number;
  dailyStreakAt?: number;
}

export interface PushToken extends HasCreatedAndUpdatedAt, HasDeviceName {
  token: string;
}

export interface ReminderDate extends HasCreatedAndUpdatedAt, HasDeviceName {
  reminderDateTime: Date;
}

export interface OnboardingCategory extends HasCreatedAndUpdatedAt, HasDeviceName {
  onboardingCategories: OnboardingCategoryType[];
}

export interface SubscriptionInterval {
  purchaseDate: number;
  expirationDate: number;
}

export interface Deal {
  type?: DealType;
  createdAt?: number;
  endAt?: number;
  context?: string;
}

export type Filters = {
  pillars: string[];
  goals: string[];
  categories: string[];
};

export type Tag = {
  value: string;
  text: string;
};

export const TAGS: Tag[] = [{ value: 'notCorporateFriendly', text: 'Not corporate friendly' }];
